import { render, staticRenderFns } from "./stepItem.vue?vue&type=template&id=a1187fc4&scoped=true&"
import script from "./stepItem.vue?vue&type=script&lang=ts&"
export * from "./stepItem.vue?vue&type=script&lang=ts&"
import style0 from "./stepItem.vue?vue&type=style&index=0&id=a1187fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1187fc4",
  null
  
)

export default component.exports